export default __webpack_public_path__ + "static/media/jugueton.453e2b9f.png";